import React from "react";
import styles from "./ribbon.module.css";

const Ribbon: React.FC = () => {
  const env: string = import.meta.env.VITE_ENV || "";

  const isProduction = (): boolean => !env || env === "production" || env === "prod";

  return (
    <div>{!isProduction() && <div className={`${styles.ribbon} ${styles[env]}`}>{import.meta.env.VITE_ENV}</div>}</div>
  );
};

export default Ribbon;
